import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import color from 'color';
import _ from 'lodash';
import SMTeamLogo from '../SMTeamLogo';

//These lines are needed to get common i18
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const TblContainer = styled.table`
    border-collapse: separate;
    width: 100%;
`;

const TH = styled.th`
    text-align: center;
    font-size: 18px;
    line-height: 38px;
    color: ${props => props.theme.color};
    background-color: ${props => props.theme.content.accentColor};
    font-weight: ${props => props.theme.fonts.main.bold};
`;

const TD = styled.td`
    font-size: 24px;
    line-height: 38px;
    text-align: ${props => (props.left ? 'left' : 'center')};
    padding-left: ${props => props.paddingLeft};
    font-weight: ${props => props.theme.fonts.main.bold};

    &.wdp-nowrap {
        white-space: nowrap;
    }
    div {
        display: flex;
        align-items: center;
        padding: 0 9px;
    }
    .wdp-team-logo {
        margin-right: 15px;
    }

    &.num {
    }
`;

const QualRelTR = styled.tr`
    position: relative;
    color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
    font-weight: ${props => props.theme.fonts.main.bold};
    background-color: ${props =>
        props.type ? color(props.theme.qualRelColors[props.type]).toString() : props.theme.content.accent2Color};
    background-color: ${props => props.isFirstRow && props.theme.qualRelColors.leagueWinner};

    td {
        position: relative;
        color: ${props => (props.high ? props.theme.content.accentTextColor : props.theme.color)};
        font-weight: ${props => props.theme.fonts.main.bold};
    }
`;

const Row = ({ row, qualRel, highlight, tournamentId, isFirstRow }) => {
    return (
        <QualRelTR key={row.rank} type={qualRel && row.rankType} high={highlight} isFirstRow={qualRel && isFirstRow}>
            <TD className="num">{row.rank}</TD>
            <TD left>
                <div>
                    <SMTeamLogo tournamentId={tournamentId} teamId={row.teamId} width={38} height={38} />
                    {row.teamName}
                </div>
            </TD>
            <TD>{row.matchesPlayed}</TD>
            <TD className="wdp-nowrap">{row.goalsScored + ' - ' + row.goalsConceded}</TD>
            <TD>{row.points}</TD>
        </QualRelTR>
    );
};

const Header = ({ showLogo = true, props }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');

    return (
        <tr>
            <TH width="45px" className="__c__b1_style1">
                <span className="__c__c1_style1">#</span>
            </TH>
            <TH className="__c__b1_style1" />
            <TH width="45px" className="__c__b1_style1">
                <span className="__c__c1_style1">{i18('matches.short', lang)}</span>
            </TH>
            <TH width="120px" className="__c__b1_style1">
                <span className="__c__c1_style1">{i18('goals.short', lang)}</span>
            </TH>
            <TH width="45px" className="__c__b1_style1">
                <span className="__c__c1_style1">{i18('points.short', lang)}</span>
            </TH>
        </tr>
    );
};

Row.contextTypes = {
    info: PropTypes.object,
    teamLogoSettings: PropTypes.object
};

Header.contextTypes = {
    info: PropTypes.object,
    teamLogoSettings: PropTypes.object
};

const Container = ({ children }) => (
    <TblContainer>
        <tbody>{children}</tbody>
    </TblContainer>
);

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/tables/MainTTStyle1.js
 **/